import { b, r, s14, s24 } from '@theswing/rhythm';
import styled from 'styled-components';

export const InviteContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  & > img {
    width: 96px;
    height: 96px;
    margin: 16px 0;
  }

  & > section {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 40px;

    & > h1 {
      color: ${props => props.theme.colors.black};
      margin: 0 0 8px 0;
      ${s24};
      ${b};
    }

    & > p {
      color: ${props => props.theme.colors.g600};
      ${s14};
      ${r};
    }
  }
`;